import { render, staticRenderFns } from "./MultiQueuesDashboard.vue?vue&type=template&id=b75a4578&scoped=true"
import script from "./MultiQueuesDashboard.vue?vue&type=script&lang=js"
export * from "./MultiQueuesDashboard.vue?vue&type=script&lang=js"
import style0 from "./MultiQueuesDashboard.vue?vue&type=style&index=0&id=b75a4578&prod&lang=scss"
import style1 from "./MultiQueuesDashboard.vue?vue&type=style&index=1&id=b75a4578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75a4578",
  null
  
)

export default component.exports